
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/ModalDialog.html",
      function () {
        return require("private-next-pages/Web-Elements/ModalDialog.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/ModalDialog.html"])
      });
    }
  